import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { StoreRouterConnectingModule } from '@ngrx/router-store';

import { CustomSerializer, reducers, routerFeatureKey } from './router.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(routerFeatureKey, reducers),
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
    }),
  ],
  providers: [],
})
export class RouterStoreModule {}
